import { CRUD, CrudModel } from '../../classes'
import { type ClinicianData } from '../clinician'
import { EstimateCharge } from './estimate-charge'
import { EstimateTemplateData } from './estimate-template.data'

@CRUD({
  base: '/crud/estimate-templates',
})
export class EstimateTemplateModel extends CrudModel {
  name: string
  facilityIds?: string[]
  categoryId?: string | null
  charges?: EstimateCharge[]
  createdBy?: string | Pick<ClinicianData, 'id' | 'clinicId' | 'name'>

  constructor(data?: EstimateTemplateData) {
    super(data, true)
  }

  override toJSON() {
    return Object.assign(super.toJSON(), {
      name: this.name,
      facilityIds: this.facilityIds,
      categoryId: this.categoryId,
      charges: this.charges,
      createdBy: typeof this.createdBy === 'string' ? this.createdBy : this.createdBy?.id,
    })
  }

  get hasPBCharges() {
    return this.charges?.some(charge => charge.type === 'pb')
  }

  get hasHBCharges() {
    return this.charges?.some(charge => charge.type === 'hb')
  }
}
